import moment from "moment";

export type TeeSheetNavigationParams = {
  autoOpenDailyStatus?: boolean;
  preserveTeeSheetDate?: boolean;
  teeSheetDate?: Date;
};

export type TeeSheetLocationState = {
  params?: TeeSheetNavigationParams;
};

export function resolveTeeSheetMountDate(options: {
  urlDate: string | null;
  params?: TeeSheetNavigationParams;
  existingSelectedDate: Date | null;
}): Date | null {
  const { urlDate, params, existingSelectedDate } = options;

  if (urlDate) {
    return new Date(moment(urlDate)?.local()?.toISOString());
  }

  if (params?.teeSheetDate) {
    return new Date(params.teeSheetDate);
  }

  if (params?.preserveTeeSheetDate && existingSelectedDate) {
    return null;
  }

  return new Date();
}
